export default class AppConstants {
    public static readonly REDIRECT_TO_APPS_IF_READY_REQ_PARAM =
        'redirectToAppsIfFullySetup'
}
